if (!customElements.get('shop-categories')) {
  customElements.define(
    'shop-categories',
    class ShopCategories extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('.shop-categories__track');
        this.buttons = Array.from(this.querySelectorAll('.shop-categories__nav-btn'));
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = parseInt(this.dataset.interval, 10) || 3000;
        this.timer = null;
        this.resumeTimer = null;

        if (!this.track) return;

        this.buttons.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.scrollOneStep(btn.dataset.direction === 'prev' ? -1 : 1);
            this.pauseThenResume();
          });
        });

        this.track.addEventListener('scroll', () => this.updateNavState());
        this.track.addEventListener('pointerdown', () => this.pauseThenResume());
        this.track.addEventListener('wheel', () => this.pauseThenResume(), { passive: true });
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => {
          if (this.autoplay) this.startAutoplay();
        });

        this.updateNavState();
        if (this.autoplay) this.startAutoplay();
      }

      cardStep() {
        const card = this.track.querySelector('.shop-categories__card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap || 20);
        return (card?.offsetWidth || 220) + gap;
      }

      scrollOneStep(direction) {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        if (direction > 0 && this.track.scrollLeft >= maxScroll - 4) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        if (direction < 0 && this.track.scrollLeft <= 4) {
          this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
          return;
        }
        this.track.scrollBy({ left: direction * this.cardStep(), behavior: 'smooth' });
      }

      startAutoplay() {
        this.stopAutoplay();
        this.timer = setInterval(() => this.scrollOneStep(1), this.interval);
      }

      stopAutoplay() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      pauseThenResume() {
        this.stopAutoplay();
        if (this.resumeTimer) clearTimeout(this.resumeTimer);
        if (!this.autoplay) return;
        this.resumeTimer = setTimeout(() => this.startAutoplay(), this.interval * 1.5);
      }

      updateNavState() {
        const prevBtn = this.buttons.find((b) => b.dataset.direction === 'prev');
        const nextBtn = this.buttons.find((b) => b.dataset.direction === 'next');
        if (!prevBtn || !nextBtn) return;

        const atStart = this.track.scrollLeft <= 4;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;

        prevBtn.classList.toggle('shop-categories__nav-btn--active', !atStart);
        nextBtn.classList.toggle('shop-categories__nav-btn--active', !atEnd);
      }
    }
  );
}